import React from 'react';
import equal from 'fast-deep-equal';
import {ThemeSpacingName} from '@di-nxt/components';
import {CellSpanInfo} from '.';
import {CellSpanRenderer} from './CellSpanRenderer';

type Props<TCellSpanData = any> = {
  prevCellSpanDataRef: React.MutableRefObject<
    | {
        data: CellSpanInfo<TCellSpanData>[] | undefined;
        component: any;
      }[]
    | undefined
  >;
  colCount: number;
  fixedColWidths: Array<number | undefined>;
  rowIndex: number;
  fixedColumnIndex?: number;
  cellSpanInfos: Array<CellSpanInfo<TCellSpanData>>;
  spacing?: ThemeSpacingName;
  minHeight?: number;
  onRenderCellSpan: (
    row: number,
    cellSpanInfo: TCellSpanData,
  ) => React.ReactElement<any>;
  onRenderCellSpanCaption?: (
    row: number,
    cellSpanInfo: TCellSpanData,
  ) => React.ReactElement<any>;
};

export const CellSpanMemoizer = function <TCellSpanData = any>(
  props: Props<TCellSpanData>,
) {
  const {
    prevCellSpanDataRef,
    colCount,
    fixedColWidths,
    rowIndex,
    fixedColumnIndex,
    cellSpanInfos,
    spacing: cellSpanSpacing,
    minHeight: cellSpanMinHeight,
    onRenderCellSpan,
    onRenderCellSpanCaption,
  } = props;

  if (prevCellSpanDataRef.current === undefined) {
    prevCellSpanDataRef.current = [];
  }
  if (prevCellSpanDataRef.current[rowIndex] === undefined) {
    prevCellSpanDataRef.current[rowIndex] = {
      component: undefined,
      data: cellSpanInfos,
    };
  }

  const cellInfoRef = prevCellSpanDataRef.current[rowIndex];

  if (
    cellInfoRef.component === undefined ||
    !equal(cellSpanInfos, cellInfoRef.data)
  ) {
    // if (cellInfoRef.component !== undefined) {
    //   console.log(
    //     'Row rerender',
    //     rowIndex,
    //     'changed',
    //     cellInfoRef.data,
    //     cellSpanInfos,
    //   );
    // }
    cellInfoRef.data = cellSpanInfos;
    cellInfoRef.component = (
      <CellSpanRenderer<TCellSpanData>
        cellSpanInfos={cellSpanInfos}
        colCount={colCount}
        fixedColWidths={fixedColWidths}
        fixedColumnIndex={fixedColumnIndex}
        rowIndex={rowIndex}
        cellSpanSpacing={cellSpanSpacing}
        cellSpanMinHeight={cellSpanMinHeight}
        onRenderCellSpan={onRenderCellSpan}
        onRenderCellSpanCaption={onRenderCellSpanCaption}
      />
    );
  }
  return cellInfoRef.component;
};
